<div class="wn__roadmap-icon" aria-hidden="true">
  @if (cardIndex() === 0) {
    <img src="icons/milestone-1.svg" width="28" height="28" alt="" aria-hidden="true" />
  }
  @if (cardIndex() === 1) {
    <img src="icons/milestone-2.svg" width="28" height="28" alt="" aria-hidden="true" />
  }
  @if (cardIndex() === 2) {
    <img src="icons/milestone-3.svg" width="28" height="28" alt="" aria-hidden="true" />
  }
</div>
<div class="wn__roadmap-body">
  <p class="wn__roadmap-release">{{ item().quarter }}</p>
  <p class="wn__roadmap-title">{{ item().title }}</p>
  @for (para of item().desc.split('\n\n'); track para) {
    <p class="wn__roadmap-desc">{{ para }}</p>
  }
</div>
